import { gql, QueryResult, useQuery } from "@apollo/client";

import { GraphicByIdQuery } from "../../generated/gql/graphql";

const GET_GRAPHIC = gql`
  query graphicById($id: ID!) {
    graphic(id: $id) {
      id
      name
      asset {
        width
        height
      }
      previewUrl
    }
  }
`;

export function useGraphic(
  graphicId: string | undefined | null,
): QueryResult<GraphicByIdQuery> {
  return useQuery(GET_GRAPHIC, {
    variables: {
      id: graphicId,
    },
    skip: !graphicId,
  });
}
